import { render } from "./KingdomProfile.vue?vue&type=template&id=3a817367"
import script from "./KingdomProfile.vue?vue&type=script&lang=js"
export * from "./KingdomProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/KingdomProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a817367"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a817367', __exports__)) {
    api.reload('3a817367', __exports__)
  }
  
  module.hot.accept("./KingdomProfile.vue?vue&type=template&id=3a817367", () => {
    api.rerender('3a817367', render)
  })

}


export default __exports__